import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { LastSalesTableComponent } from "@shared/components/last-sales-table/last-sales-table.component";
import {
  OrderDetailsDialogComponent,
  OrderDetailsDialogData,
} from "@shared/modals/order-details-dialog/order-details-dialog.component";
import { finalize } from "rxjs";
import { LoadingComponent } from "../../../../../../shared/components/loading/loading.component";
import { OrdersService } from "../../../../../services/orders.service";
import { SalesService } from "../../../../../services/sales.service";

@Component({
  selector: "app-last-sales-page",
  imports: [CommonModule, LastSalesTableComponent, LoadingComponent],
  templateUrl: "./last-sales-page.component.html",
  styleUrl: "./last-sales-page.component.scss",
})
export class LastSalesPageComponent {
  private readonly _salesService = inject(SalesService);
  private readonly _dialog = inject(MatDialog);
  private readonly _ordersService = inject(OrdersService);

  loading = false;

  sales$ = this._salesService.getSales({
    page: 0,
    rows: 4,
  });

  handleSaleDetailsClick(orderId: number) {
    this.loading = true;
    this._ordersService
      .getOrderById(orderId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((order) => {
        this._dialog.open(OrderDetailsDialogComponent, {
          width: "800px",
          maxWidth: "95vw",
          data: { order } as OrderDetailsDialogData,
        });
      });
  }
}
